module.exports = __webpack_public_path__ + "static/gem-visa-cards-horizontal-925147eac2a0de6a399a50066aa53a21.png";